import { service } from '@ember/service';
import Controller from '@ember/controller';

export default class SiteController extends Controller {
  @service session;
}
